import { defineMessages } from "react-intl";

export const messages = defineMessages({
  assignCollectionDialogLabel: {
    id: "f0hXz4",
    defaultMessage: "Search Collection",
    description: "dialog header",
  },
  assignCollectionDialogPlaceholder: {
    id: "JiRKgJ",
    defaultMessage: "Search by collection name, etc...",
    description: "dialog search placeholder",
  },
  assignCollectionDialogHeader: {
    id: "5tMkmJ",
    defaultMessage: "Assign Collection",
    description: "dialog header",
  },
  confirmBtn: {
    id: "cryH86",
    defaultMessage: "Assign and save",
    description: "assign collections to sale and save",
  },
  noCollectionsFound: {
    id: "68Wuv1",
    defaultMessage: "No collections found",
    description: "search results",
  },
});
